import BaseService from "../base-service";
import NetworkUrls from "../network-urls";

class FindRoomService extends BaseService {

    async request (params, accessToken = null) {
        const query = `
        fragment roomPriceEdge on RoomPriceEdge {
            from {
                id,
                text (lang: $lang) {
                    color,
                    left_label,
                    title,
                    sub_title,
                    description,
                    display_infos
                }
            },
            hostingPrice,
            totalPrice,
            touristTax,
            additionalPrice,
            extraAdditionalPrice,
            optionsBasePrice,
            optionsAdditionalPrice,
        }
        query ($color: String, $hasZone: Boolean!, $isAuth: Boolean!, $lang: Lang!, $query: String, $start: Date!, $end: Date!, $travelers: TravelersInput!, $equipments: [CID], $zone: CID!, $group: [CID], $businessCode: String) {
            RoomZone @include (if: $hasZone) {
                one (id: $zone) {
                    name,
                    room_groups (limit: 100) {
                        id,
                        text (lang: $lang) {
                            name
                        }
                    }
                }
            },
            Room {
                available: search(start: $start, end: $end, travelers: {adults: 1}) { id },
                search (start: $start, end: $end, query: $query, travelers: $travelers, equipments: $equipments, zone: $zone, group: $group, businessCode: $businessCode) {
                    id,
                    is_favorite @include(if: $isAuth),
                    provider,
                    price_plans {
                        date,
                        input_prices {
                            nbGuest,
                            edges {
                                ...roomPriceEdge,
                                altPrice {
                                    ...roomPriceEdge
                                } 
                            },
                            totalPrice,
                            touristTax,
                            guestTotalPrice
                        }
                    }
                    available_equipments,
                    equipments {
                        id,
                        icon (color: $color),
                        text (lang: $lang) {
                            name
                        },
                        display_order
                    },
                    main_picture {
                        absolute_path
                    },
                    pictures (limit: 5, sortBy: NUMBER) {
                        absolute_path
                    },
                    color,
                    area,
                    number,
        
                    label (lang: $lang) {
                        short
                    },
                    text (lang: $lang) {
                        short_name
                    }
                    room_group {
                        id,
                        text (lang: $lang) {
                            name
                        },
                        room_zone {
                            name
                        }
                    },
                    position {lat, lng}
                }
            }
        }`;
        params.hasZone = !!params.zone;
        if (params.zone === null) params.zone = 0;
        if (!params.color) params.color = '#ffffff';
        const options = {
            method: 'POST',
            url: NetworkUrls.graphql,
            data: {
                query,
                variables: params
            }
        }
        if (accessToken) {
            options.headers = {
                Authorization: accessToken
            }
        }

        return this._exec(options);
    }

}

export const findRoomService = new FindRoomService();



// WEBPACK FOOTER //
// ./src/network/services/find-room.service.js